import {h, Component} from "preact";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

import ManagerUserlist from "./manager-userlist";
import ManagerBetslist from "./manager-betslist";
import ManagerStructurelist from "./manager-structurelist";
import {ManagerTransactionHistory} from "./manager-transaction-history";
import {UserTransactions} from "./menu-dashboard";
import ManagerReport from "./manager-report";

export default class ManagerLayout extends Component {
    state = {
        currentpage: 'dashboard',
        currentcomponent: null,
        menu: [
            {
                label: window.Translation(msg`Pannello Admin`),
                entries: [
                    {
                        label: window.Translation(msg`Lista Sottorete`),
                        url: 'list-structure',
                        icon: '',
                        component: ManagerStructurelist
                    },
                    {
                        label: window.Translation(msg`Lista Utenti`),
                        url: 'list-players',
                        icon: '',
                        component: ManagerUserlist
                    },
                    {
                        label: window.Translation(msg`Report`),
                        url: 'manager-report',
                        icon: '',
                        component: ManagerReport
                    }
                ]
            },
            {
                label: window.Translation(msg`Dettaglio Giocate`),
                entries: [
                    {
                        label: window.Translation(msg`Lista Scommesse`),
                        url: 'bets',
                        icon: '',
                        component: ManagerBetslist
                    },
                    {
                        label: window.Translation(msg`Movimenti Sottorete`),
                        url: 'manager-transaction-history',
                        icon: '',
                        component: ManagerTransactionHistory
                    },
                    {
                        label: window.Translation(msg`Movimenti Utenti`),
                        url: 'user-transaction-history',
                        icon: '',
                        component: UserTransactions
                    }
                ]
            }
            /*,
            {
                label: window.Translation(msg`Pagamenti`),
                entries: [
                    {
                        label: window.Translation(msg`Giroconto`),
                        url: 'giroconto',
                        icon: '',
                        component: ManagerTopup
                    },
                    {
                        label: window.Translation(msg`Versamento`),
                        url: '',
                        icon: ''
                    },
                    {
                        label: window.Translation(msg`Prelievo`),
                        url: '',
                        icon: ''
                    }
                ]
            }*/
        ]
    }

    componentWillMount() {
        if (!!this.props.page) {
            this.setState({currentpage: this.props.page});
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (!!nextProps.page) {
            this.setState({currentpage: nextProps.page});
        }
    }

    render() {
        const CurrentComponent = this.state.currentcomponent;
        return <div class="max-w-7xl mx-auto min-h-[inherit] bg-slate-200 text-black">
			<div class="main-content-container flex flex-row bg-slate-100 text-black min-h-[inherit]">
				<div class="logged-affiliate-admin-menu panel flex-shrink-0 w-56 shrink-0" style="min-height:500px">
					{this.state.menu.map(
						menu => <ul>
							<li><span class="logged-affiliate-admin-menu-label block uppercase text-sm p-1 ml-2 mt-3 mb-2">{menu.label}</span></li>
							{menu.entries.map(
								entry => <li>
									<a
										href="javascript:void(0);"
										onClick={e => this.setState({currentpage: entry.url, currentcomponent: entry.component})}
										class={"logged-affiliate-admin-menu-item block text-sm py-1 px-2 font-bold ml-6" + (entry.url === this.state.currentpage? ' active after:inline-block after:leading-5 after:text-sm after:float-right' : '')}
									>
										{entry.label}
									</a>
								</li>
							)}
						</ul>
					)}
				</div>
				<div id="user-menu-page" class="logged-affiliate-admin-page bg-white w-full text-gray-900 overflow-x-auto">
					{!!CurrentComponent && <CurrentComponent key={this.state.currentpage} />}
				</div>
			</div>
		</div>;
    }
}